import React, { ReactNode } from "react";

export type BannerContentProps = {
  children: ReactNode;
};

export const BannerContent: React.FC<BannerContentProps> = ({
  children,
}: BannerContentProps) => {
  return <div className="banner__content-container">{children}</div>;
};
